module.exports = __webpack_public_path__ + "img/bn5.1c8374c3.png";